import { render, staticRenderFns } from "./ListProperty.vue?vue&type=template&id=28345642&scoped=true"
import script from "./ListProperty.vue?vue&type=script&lang=js"
export * from "./ListProperty.vue?vue&type=script&lang=js"
import style0 from "./ListProperty.vue?vue&type=style&index=0&id=28345642&prod&lang=css"
import style1 from "./ListProperty.vue?vue&type=style&index=1&id=28345642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28345642",
  null
  
)

export default component.exports